import { usePaginatedResource } from "./useCrudResource"
import { getQueueJobs } from "../api/queueJobApi"

export const QUEUE_JOBS_QUERY_KEY = "queue-jobs"

export const useQueueJobs = (params = {}, enabled = true) =>
  usePaginatedResource(QUEUE_JOBS_QUERY_KEY, getQueueJobs, params, enabled)
